module.exports = "<div class=\"training-row row\">\n    <h2>Training Times</h2>\n    <div *ngFor=\"let tDate of trainingDates\" class=\"col-xs-12 col-md-12 training-date-col\">\n        <training-date [trainingDate]=\"tDate\"></training-date>\n    </div>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app.component.html
 ** module id = 368
 ** module chunks = 0
 **/